import React from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { PanelInfo } from '../types/dashboard.types';
import { STATUS_COLORS } from '@/shared/constants/colors';

const { Text } = Typography;

interface PanelStatusCircleProps {
  readonly panelInfo: PanelInfo;
}

const STATUS_COLOR_MAP = {
  active: STATUS_COLORS.ACTIVE,
  stopped: STATUS_COLORS.STOPPED,
  warning: STATUS_COLORS.WARNING,
} as const;

export const PanelStatusCircle: React.FC<PanelStatusCircleProps> = ({
  panelInfo,
}) => {
  const navigate = useNavigate();

  const handleClickPanelCircle = (): void => {
    navigate(`/panels/${panelInfo.panelId.toPrimitive()}`);
  };

  const statusColor = STATUS_COLOR_MAP[panelInfo.status.toKey()];

  return (
    <div
      className="flex items-center gap-3 cursor-pointer transition-colors duration-200 hover:bg-gray-50 py-2 px-2 rounded"
      onClick={handleClickPanelCircle}
    >
      <div
        className="flex-shrink-0 rounded-full border-2 border-white shadow-sm w-8 h-8 md:w-12 md:h-12"
        style={{
          backgroundColor: statusColor,
        }}
      />
      <Text className="text-sm">
        {panelInfo.panelName}
      </Text>
    </div>
  );
};